import './Checkbox-2aef6693.css';

var classes = {"Checkbox":"prc-Checkbox-Checkbox-gIwWX"};

export { classes as default };
